export const ALLOWED_WALUTOMAT_HOSTS = ['www.walutomat.pl', 'www.walutomat.com']
export const CUURENCY_AMOUNT_INPUT_MAX_INTEGER_LENGTH = 7

export const DEFAULT_BASE_AMOUNT = '100.00'
export const DEFAULT_COUNTER_AMOUNT = '425.50'

export const DEFAULT_DEBOUNCE_TIME = 300
export const DEFAULT_REFRESH_TIME = 10 * 1000

export const REGISTRY_URL = process.env.REGISTRY_URL || 'https://user.walutomat.pl/#/registration'

export const LOGO_PATH = '/wp-content/themes/wt-theme/assets/images/brand/walutomat-wide.svg'
export const DARK_MODE_LOGO_PATH = '/wp-content/themes/wt-theme/assets/images/brand/walutomat-white-wide.svg'
export const QUESTION_MARK_ICON_PATH = '/wp-content/themes/wt-theme/assets/images/how-it-works/question-mark.svg'
